import React, { FC, useMemo } from 'react';
import { Button, ButtonVariant, Icon, StsIconName } from '@packages/ui/shared';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { StyleSheet } from 'react-native';
import colors from '@packages/core/styles/colors';

export interface ActionButton {
    color?: keyof typeof colors;
    id: string;
    name: StsIconName | string;
    onPress: () => void;
    tooltip: string;
    variant?: ButtonVariant;
}

export interface ActionButtonsProps {
    actions: ActionButton[];
}

const styles = StyleSheet.create({
    tooltip: {
        fontSize: 15,
        marginTop: 5,
        minWidth: 50,
        opacity: 0.7,
    },
});

export const ActionButtons: FC<ActionButtonsProps> = ({ actions }) => {
    const renderedButtons = useMemo(
        () =>
            actions.map(({ id, tooltip, name, variant = 'ghost-blue', color = 'blueOne', onPress }) => (
                <OverlayTrigger
                    key={id}
                    placement="bottom"
                    overlay={
                        <Tooltip style={styles.tooltip} id={id}>
                            {tooltip}
                        </Tooltip>
                    }
                >
                    <Button testID="button-test-id" id={id} variant={variant} onPress={onPress}>
                        <Icon name={name} color={color} size={24} />
                    </Button>
                </OverlayTrigger>
            )),
        [actions]
    );

    return <>{renderedButtons}</>;
};
